export default "__VITE_ASSET__6e5314ca__"